import { cx } from "@suse-o11y/class-variance";
import { copyToClipboard } from "@suse-o11y/copy-to-clipboard";
import { IconCopyOutlined } from "@suse-o11y/icons";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React from "react";

import { DONT_AUTO_DISMISS, notification } from "../notification/Notification";

const LABEL = "Copy to clipboard";

export interface CopyToClipboardProps {
	className?: string;
	children?: React.ReactNode;
}

/**
 * The component copies the text content of its children HTML nodes to the clipboard.
 */
export class CopyToClipboard extends React.PureComponent<CopyToClipboardProps> {
	private readonly contentRef: React.RefObject<HTMLDivElement> = React.createRef();

	private readonly onCopyToClipboard = async () => {
		if (!this.contentRef.current) {
			return;
		}

		const [failure, success] = await copyToClipboard({ text: this.contentRef.current.innerText });

		if (failure == null) {
			notification.success({ message: success });
		} else {
			notification.error({
				message: failure,
				duration: DONT_AUTO_DISMISS,
			});
		}
	};

	render() {
		return (
			<div
				className={cx(
					"group/copy-to-clipboard",
					"relative",
					"[&_pre]:mb-0 [&_pre]:rounded-sm [&_pre]:border [&_pre]:border-grey-400 [&_pre]:bg-grey-200 [&_pre]:px-3 [&_pre]:py-[7px] [&_pre]:text-grey-800 [&_pre]:leading-[22px]",
					this.props.className,
				)}
			>
				<div className="copyToClipboard__value" ref={this.contentRef}>
					{this.props.children}
				</div>

				<TooltipBoundary>
					<TooltipTrigger
						aria-label={LABEL}
						className="copyToClipboard__action button button-tertiary button-circle absolute -right-1.5 -bottom-1.5 not-group-hover/copy-to-clipboard:opacity-0 transition-all"
						onClick={this.onCopyToClipboard}
					>
						<IconCopyOutlined />
					</TooltipTrigger>

					<Tooltip className="tooltip/tooltip" side="top">
						{LABEL}
					</Tooltip>
				</TooltipBoundary>
			</div>
		);
	}
}
